import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
import { CheckStudentStatusService } from './check_student_status_service';
import { ApplicationConfiguration } from '../models/app_config_model';
export class UserModesService {
  isUserModeStudent: boolean;
  constructor(
    private accountModel: AccountModel,
    private NetworkUrlConfiguration: any,
    private ngCheckStudentStatusService: CheckStudentStatusService,
    private $state: ng.ui.IStateService,
    private loginConfigModel: any,
    private appConfigModel: ApplicationConfiguration
  ) {}
  get hasAdvisorRole() {
    return _4.includes(this.accountModel.groupNames, `advisor`);
  }
  get hasStudentRole() {
    return _4.includes(this.accountModel.groupNames, `use_student`);
  }
  get hasMultipleRoles() {
    return this.accountModel.groupNames.length > 1;
  }
  get isAdvisorOnly() {
    return !this.hasMultipleRoles && this.hasAdvisorRole;
  }
  get isStudentOnly() {
    return !this.hasMultipleRoles && this.hasStudentRole;
  }
  get nonAdvisorRoles() {
    return _4.without(this.accountModel.groupNames, `advisor`);
  }
  get hasNonAdvisorDefaultRole() {
    return this.nonAdvisorRoles.length === 1;
  }
  get defaultToStudent() {
    return this.hasNonAdvisorDefaultRole && this.hasStudentRole;
  }
  get isContentManagerOnly() {
    return this.hasMultipleRoles && !this.hasAdvisorRole && !this.hasStudentRole;
  }
  get defaultToContentManager() {
    return this.nonAdvisorRoles.length > 0 && !this.hasStudentRole;
  }
  get hasContentManagerRole() {
    const otherRoles = _4.without(this.accountModel.groupNames, `advisor`, `use_student`);
    return otherRoles.length > 0;
  }
  set userMode(mode: string | undefined) {
    this.isUserModeStudent = mode === 'student';
    this.NetworkUrlConfiguration.configure({
      defaultHeaders: {
        'user-mode': mode
      }
    });
  }
  accessAsStudent() {
    this.userMode = `student`;
    this.ngCheckStudentStatusService.run();
  }
  accessAsContentManager() {
    window.open(`/content`, '_self');
  }
  processDefaultMode() {
    /* Group Roles as of Oct 10, 2018
      advisor
      content_manager
      eab_content_manager
      eab_delivery
      instructor
      member_content_manager
      path_default_editor
      path_default_moderator
      path_default_viewer
      path_editor
      path_moderator
      path_publisher
      path_viewer
      program_editor
      program_global_moderator
      program_moderator
      program_publisher
      program_viewer
      use_contentmanager
      use_student
      use_student_selector
    */
    this.isUserModeStudent = false;
    if (this.isStudentOnly || this.defaultToStudent) {
      this.accessAsStudent();
      return;
    }
    if (this.isContentManagerOnly || this.defaultToContentManager) {
      this.accessAsContentManager();
      return;
    }
    this.$state.go(`user-modes`);
  }
  checkTOS() {
    if (this.accountModel.acceptedTerms) {
      this.processDefaultMode();
    } else {
      this.$state.go(`tos`);
    }
  }
  forceAuthentication() {
    this.accountModel.clear();
    this.loginConfigModel.clear();
    this.userMode = undefined;
    this.$state.go('authentication');
  }

  get isStudentPreview() {
    // Student Preview user has nk as `FAKE_my_user_name_$$_student_nk`;
    const FAKESTUDENTPREFIX = `FAKE`;
    return _4.isEqual(_4.first(_4.split(this.accountModel.student_nk, '_')), FAKESTUDENTPREFIX);
  }
}



// WEBPACK FOOTER //
// ./app/lib/user_modes/user_modes_service.ts